export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAW_QwpMSSCcIZdJbIRvheMWczqiKSN6AI',
    authDomain: 'jammcard-fe23d.firebaseapp.com',
    databaseURL: 'https://jammcard-fe23d.firebaseio.com',
    projectId: 'jammcard-fe23d',
    storageBucket: 'jammcard-fe23d.appspot.com',
    messagingSenderId: '414187709185',
    appId: '1:414187709185:web:5c3c606d76fd483962f100',
    measurementId: 'G-BJTPJ4Y7EW',
  },
  log: true,
};

export const STRIPE = {
  PUBLISHABLE_KEY: 'pk_test_zuqqbdRAeGOFSC3imI9rRReh00bQaX4SLg',
  CLIENT_ID: 'ca_GAjweccMcvslCGS9YzfUuAFpo9OCkwxg',
  REDIRECT_BASE_URI: 'https://portal.staging-jammcard.com/seller-payout-method-confirm',
};

export const TEMP_STORAGE_API_KEY = '3fba345e-d9ee-4a4b-b410-9f4005ab2451';
